import { convertFreelanceUser } from "@/api/services/authentication"
import { useAuthStore } from "@/stores/useAuthStore"
import { checkPermissions } from "@/utils/checkPermissions"
import { useMutation } from "@tanstack/react-query"
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router"
import { useEffect, useMemo } from "react"
import { LoginWrapper } from "toptaal-shared"

export const Route = createFileRoute("/freelancer_omzetten/")({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      token: String(search.token),
      email: String(search.email),
    }
  },
  beforeLoad: () => checkPermissions("update", "employees"),
})

function RouteComponent() {
  const router = useRouter()
  const setToken = useAuthStore((state) => state.setToken)
  const setRefreshToken = useAuthStore((state) => state.setRefreshToken)

  const { token, email } = useSearch({
    from: "/freelancer_omzetten/",
  })

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async ({ token, email }: { token: string; email: string }) =>
      convertFreelanceUser(token, email),
    onSuccess: async (data) => {
      const { token, refreshToken } = data.data

      setToken(token)
      setRefreshToken(refreshToken)

      router.navigate({ to: "/" })
    },
  })

  useEffect(() => {
    mutate({ token, email })
  }, [token, email, mutate])

  const statusMessage = useMemo(() => {
    if (isPending) return "Account omzetten..."
    if (isSuccess)
      return "Account successvol omgezet! Je wordt nu doorgestuurd..."
    if (isError)
      return "Er is een fout opgetreden bij het omzetten. Probeer het opnieuw."

    return null
  }, [isPending, isSuccess, isError])

  return (
    <LoginWrapper title="Account omzetten">
      <p className="text-center">{statusMessage}</p>
    </LoginWrapper>
  )
}
